import React from 'react';

import './cardWrapper.scss';

interface ICardWrapper {
  width?: any;
  children?: any;
  className?: any;
  gridColumnEnd?: any;
  gridRowEnd?: any;
}

const CardWrapper: React.FC<ICardWrapper> = ({ children, width, className, gridColumnEnd, gridRowEnd }) => {
  return (
    <div className={`card-wrapper ${className}`} style={{ width: width, gridColumnEnd: gridColumnEnd, gridRowEnd: gridRowEnd }}>
      {children}
    </div>
  );
};

export default CardWrapper;
